import { IModifier } from 'features/menu/components/product-detail/modifier/types';
import { MultipliersSelections } from 'features/menu/components/product-wizard/types';

import { ILocalizedMenuEntry } from 'state/unified-menu/types';

export type CustomizationRenderItem = {
  item: ILocalizedMenuEntry;
  index: number;
  rowIndex: number;
};

// Order Matters for UI!
export enum DrinkCategory {
  SOFTS,
  SHAKES,
  FROZENS,
  OTHERS,
}

export enum ComboSlotType {
  DRINKS = 'drinks',
  SIDES = 'sides',
  PICKER_ASPECT = 'pickerAspect',
}

/** Localize keys — add copy in Localize, not en/fr.json in-repo. */
export const CATEGORY_LABEL_KEY: Record<DrinkCategory, string> = {
  [DrinkCategory.SOFTS]: 'drinkCategorySoftDrinks',
  [DrinkCategory.SHAKES]: 'drinkCategoryShakes',
  [DrinkCategory.FROZENS]: 'drinkCategoryFrozens',
  [DrinkCategory.OTHERS]: 'drinkCategoryOthers',
};

/** English UI fallback until Localize publishes the keys above. */
export const CATEGORY_LABEL_FALLBACK: Record<DrinkCategory, string> = {
  [DrinkCategory.SOFTS]: 'Soft Drinks',
  [DrinkCategory.SHAKES]: 'Shakes',
  [DrinkCategory.FROZENS]: 'Frozens',
  [DrinkCategory.OTHERS]: 'Others',
};

/** Stable English analytics labels (not localized). */
export const CATEGORY_ANALYTICS_NAME: Record<DrinkCategory, string> = {
  [DrinkCategory.SOFTS]: 'SOFT DRINKS',
  [DrinkCategory.SHAKES]: 'SHAKES',
  [DrinkCategory.FROZENS]: 'FROZENS',
  [DrinkCategory.OTHERS]: 'OTHERS',
};

export type SelectModifierFn = (selections: MultipliersSelections, modifier: IModifier) => void;
